
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor01Off as ObiCapacitor01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-01-off.js';
 
 
 

 
 export const ObiCapacitor01Off = createComponent({
   react: React,
   tagName: 'obi-capacitor-01-off',
   elementClass: ObiCapacitor01OffElement,
   events: {
     
   }
  });
 
 